// import axios from "axios";
import chargerActionTypes from "../types/chargerActionTypes";
import { ensureArray } from "./../../Utilities/helpers";
import chargePointService from "./../../services/chargePoint.service";


export const getAllChargers = () => async (dispatch) => {
    try {
        var response = await chargePointService.getAllChargers();
        dispatch({
            type: chargerActionTypes.GET_ALL_CHARGERS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.GET_ALL_CHARGERS_FAILURE,
            payload: error.response,
        });
    }

};

export const getChargers = () => async (dispatch) => {
    try {
        var response = await chargePointService.getChargers();
        dispatch({
            type: chargerActionTypes.GET_CHARGER_SUCCESS,
            payload: ensureArray(response.data),
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.GET_CHARGER_FAILURE,
            payload: error.response,
        });
    }

};

export const getDriverChargers = () => async (dispatch) => {

    try {
        var response = await chargePointService.getDriverChargers();
        dispatch({
            type: chargerActionTypes.GET_DRIVER_CHARGER_SUCCESS,
            payload: ensureArray(response.data),
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.GET_DRIVER_CHARGER_FAILURE,
            payload: error.response,
        });

    }
};

export const getPublicChargers = () => async (dispatch) => {

    try {
        var response = await chargePointService.getPublicChargers();
        dispatch({
            type: chargerActionTypes.GET_PUBLIC_CHARGER_SUCCESS,
            payload: ensureArray(response.data),
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.GET_PUBLIC_CHARGER_FAILURE,
            payload: error.response,
        });

    }
};

export const getFavoriteChargers = () => async (dispatch) => {

    try {
        var response = await chargePointService.getFavoriteChargers();
        dispatch({
            type: chargerActionTypes.GET_FAVORITE_SUCCESS,
            payload: ensureArray(response.data),
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.GET_FAVORITE_FAILURE,
            payload: error.response,
        });

    }
};

export const addFavoriteCharger = (id) => async (dispatch) => {

    try {
        dispatch({
            type: chargerActionTypes.START_ADD_FAVORITE
        });
        await chargePointService.addFavoriteCharger(id);
        dispatch({
            type: chargerActionTypes.ADD_FAVORITE_CHARGER_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.ADD_FAVORITE_CHARGER_FAILURE,
            payload: error.response,
        });
        throw error;
    }
};

export const removeFavoriteCharger = (id) => async (dispatch) => {

    try {
        dispatch({
            type: chargerActionTypes.START_REMOVE_FAVORITE
        });
        await chargePointService.removeFavoriteCharger(id);
        dispatch({
            type: chargerActionTypes.REMOVE_FAVORITE_CHARGER_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.REMOVE_FAVORITE_CHARGER_FAILURE,
            payload: error.response,
        });
        throw error;
    }
};

export const updateCharger = (charger) => async (dispatch) => {

    try {
        dispatch({
            type: chargerActionTypes.START_UPDATE_CHARGER,
        });
        var response = await chargePointService.updateChargerPoint(charger);
        dispatch({
            type: chargerActionTypes.UPDATE_CHARGER_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.UPDATE_CHARGER_FAILURE,
            payload: error.response,
        });

    }
};

export const addCharger = (charger) => async (dispatch) => {

    try {
        dispatch({
            type: chargerActionTypes.START_ADD_CHARGER,
        });
        var response = await chargePointService.addChargePoint(charger);
        dispatch({
            type: chargerActionTypes.ADD_CHARGER_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.ADD_CHARGER_FAILURE,
            payload: error,
        });

    }
};

export const deleteCharger = (id) => async (dispatch) => {
    try {
        dispatch({
            type: chargerActionTypes.START_DELETE_CHARGER,
        });
        var response = await chargePointService.deleteChargePoint(id);
        dispatch({
            type: chargerActionTypes.DELETE_CHARGER_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.DELETE_CHARGER_FAILURE,
            payload: error.response,
        });

    }
};

export const setSelectedCharger = (selectedCharger) => (dispatch) => {
    dispatch({ type: chargerActionTypes.SELECT_CHARGER, payload: selectedCharger });
};

export const setMyActiveChargingStationId = (id) => (dispatch) => {
    dispatch({ type: chargerActionTypes.SET_MY_ACTIVE_CHARGER_ID, payload: id });
};

export const UnSelecteCharger = (dispatch) => {
    localStorage.removeItem('selectedCharger');
    dispatch({ type: chargerActionTypes.UNSELECT_CHARGER });
};

export const resetReduxChargers = () => (dispatch) => {
    dispatch({
        type: chargerActionTypes.RESET,
    });

};

export const resetStateInfo = () => (dispatch) => {
    dispatch({ type: chargerActionTypes.RESET_STATE_INFO })
};

export const clearTransactionData = (transaction) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.CLEAR_TRANSACTION_DATA,
        payload: transaction,
    })
}

export const updateChargerGroup = (charger) => async (dispatch) => {
    dispatch({
        type: chargerActionTypes.UPDATE_CHARGER_GROUP,
        payload: charger,
    });
};

//signalR
// For UpdateConnectorStatus
export const updateConnectorStatus = (message) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.UPDATE_CONNECTOR_STATUS,
        payload: message,
    });
}

// For UpdateChargerStatus
export const updateChargerStatus = (message) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.UPDATE_CHARGER_STATUS,
        payload: message,
    });
}

// For UpdateChargingSummery
export const updateChargingSummery = (summery) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.UPDATE_CHARGING_SUMMERY,
        payload: summery,
    });
}

// For UpdateTransactionData
export const updateTransactionData = (transaction) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.UPDATE_TRANSACTION_DATA,
        payload: transaction,
    });
}

export const getSmartChargingInfo = (transactionId) => async (dispatch) => {
    try {
        const response = await chargePointService.getSmartChargingInfo(transactionId);

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        // Silent fail - caller handles null response
    }
    return null;
}
// For chargePointDetails
export const chargePointDetails = (data) => (dispatch) => {
    try {
        dispatch({
            type: chargerActionTypes.CHARGE_POINT_DETAILS_SUCCESS,
        });
        dispatch(getAllChargers());
    }
    catch (error) {
        dispatch({
            type: chargerActionTypes.CHARGE_POINT_DETAILS_FAILURE,
        });
    }
}



const chargerActions = {
    getAllChargers,
    getChargers,
    getDriverChargers,
    getPublicChargers,
    addCharger,
    updateCharger,
    deleteCharger,
    setSelectedCharger,
    setMyActiveChargingStationId,
    UnSelecteCharger,
    updateTransactionData,
    resetReduxChargers,
    updateChargerStatus,
    clearTransactionData,
    updateChargerGroup,
    updateConnectorStatus,
    getFavoriteChargers,
    addFavoriteCharger,
    removeFavoriteCharger,
    resetStateInfo,
    updateChargingSummery,
    getSmartChargingInfo,
    chargePointDetails
};
export default chargerActions;